import { Box, InputCheckBox, NumberBadge, Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import EmployeeMatch from 'modules/payroll_bundle/components/common/components/EmployeeMatch'
import getUserByItem from 'modules/payroll_bundle/components/common/helper/getUserByItem'
import type { SupplementType } from 'modules/payroll_bundle/components/common/helper/worksheet'
import { BULK_IMPORT_SUPPLEMENT } from 'modules/payroll_bundle/lib/constants'
import { supplementEmployee } from 'modules/payroll_bundle/lib/supplementEmployee'
import {
  countErrors,
  hasEmployeeAssigned,
} from 'modules/payroll_bundle/pages/SupplementsPage/BulkImport/_components/_Table/RowValidations'
import type Supplement from 'modules/payroll_bundle/store/models/Supplement'

import Amount from './Amount'

interface Props {
  onAssignEmployee?: (userId: number, index: number) => void
  checkable?: boolean
  supplement: Supplement
  supplementTypes: SupplementType[]
  onSelectItem?: (supplement: Supplement) => void
  selected?: Set<number>
  contractVersions: ContractVersions
}

const Item = ({
  selected,
  checkable,
  supplement,
  supplementTypes,
  onSelectItem,
  onAssignEmployee,
  contractVersions,
}: Props) => {
  const rowHasEmployeeAssigned = hasEmployeeAssigned(supplement)
  const user = getUserByItem(supplement)

  const renderCheckbox = () => {
    const errorCount = countErrors(supplement, supplementTypes)
    if (errorCount > 0) {
      return <NumberBadge label={errorCount} color="radicalRed1200" />
    }

    if (user) {
      const checked = selected?.has(supplement?.get('id'))

      return (
        <InputCheckBox
          checked={!!checked}
          onClick={() => onSelectItem && onSelectItem(supplement)}
        />
      )
    }

    return null
  }

  const employee = supplementEmployee(supplement, employees)

  return (
    <Table.Row>
      {checkable && <Table.Cell width={50}>{renderCheckbox()}</Table.Cell>}
      <Table.Cell width={400}>
        <Box flexDirection="row" gap="s12" alignItems="center">
          {!checkable && user && <UserAvatar size="s40" user={user} />}
          <Box>
            <Text.Normal ellipsis weight="medium" color="grey1000">
              {supplement.attributes.full_name}
            </Text.Normal>
            <Text.Normal size="200" ellipsis>
              {supplement.attributes.legal_entity_name}
            </Text.Normal>
          </Box>
        </Box>
      </Table.Cell>
      {supplementTypes.map((supplementType) => (
        <Table.Cell key={supplementType.id} width={180}>
          <Amount
            supplement={supplement}
            supplementType={supplementType}
            rowHasEmployeeAssigned={rowHasEmployeeAssigned}
          />
        </Table.Cell>
      ))}
      {checkable && onAssignEmployee && (
        <Table.Cell width={336} padding="s0">
          <Box
            paddingX="s24"
            paddingY="s16"
            border={{
              left: {
                width: 's1',
                style: 'solid',
                color: 'grey400',
              },
            }}
          >
            <EmployeeMatch
              user={user}
              index={supplement.id}
              type={BULK_IMPORT_SUPPLEMENT}
              onAssignEmployee={onAssignEmployee}
              employee={employee}
              noMatchFormat="placeholder"
              contractVersions={contractVersions}
            />
          </Box>
        </Table.Cell>
      )}
    </Table.Row>
  )
}

export default observer(Item)
